import React from 'react';
import { TEXT_COLLAPSED_MENU } from '@atlaskit/editor-common/toolbar';
import { ToolbarDropdownItemSection } from '@atlaskit/editor-toolbar';
export var MenuSection = function MenuSection(_ref) {
  var children = _ref.children,
    title = _ref.title,
    parents = _ref.parents;
  var hasSeparator = parents.some(function (parent) {
    return parent.key === TEXT_COLLAPSED_MENU.key;
  });
  return /*#__PURE__*/React.createElement(ToolbarDropdownItemSection, {
    hasSeparator: hasSeparator,
    title: title
  }, children);
};